<!-- 付款记录 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <purchaseOrderTemplate ref="purchaseOrderTemplate"></purchaseOrderTemplate>

        <div>
            <div class="demo-drawer__content data_action_form">
                <div class="page_title">
                    <el-alert :title="dataActionBox.boxTitle" type="success" effect="dark" :closable="false">
                    </el-alert>
                </div>

                <div>
                    <el-table stripe :data="returnData.list" :height="mxHeight" border style="width: 100%"
                        highlight-current-row size="mini">
                        <el-table-column v-if="tableValye.isShow==1" v-for="(tableValye,tableKey) in mxForm"
                            :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField"
                            :min-width="tableValye.fieldWeight" :label="tableValye.showField">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                                    </span>
                                </span>
                                <span v-else-if="tableValye.fieldType == 'formatter'">
                                    <span v-for="(item,i) in JSON.parse(tableValye.formatterContent)" :key="i">
                                        <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">{{item.value}}
                                        </el-tag>
                                    </span>
                                </span>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a
                                        @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                                </span>
                                <span v-else>
                                    {{scope.row[tableValye.entityField]}}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="foot">
                    <div>
                        <el-button type="primary" @click="initActionBox()">关闭</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
const mxForm = [
    {
        entityField: 'payMoney',
        isShow: 1,
        showField: '付款金额',
        fieldType: 'number'
    },
    {
        entityField: 'abookCode',
        isShow: 1,
        showField: '账簿编号',
        fieldType: 'string'
    },
    {
        entityField: 'abookName',
        isShow: 1,
        showField: '账簿名称',
        fieldType: 'string'
    },
    {
        entityField: 'createTime',
        isShow: 1,
        showField: '付款时间',
        fieldType: 'date'
    },
    {
        entityField: 'createrName',
        isShow: 1,
        showField: '创建人',
        fieldType: 'string'
    },
]
export default {
    name: "payRecord",
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                "coId": '',
                "end": '',
                "fgDate": "",
                "start": ''
            },
            showTabs: "",
            formDataList: [],
            userOneList: [],
            seId: "",
            seWidth: "",
            height: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: "",
            smId: "",
            parentSearchData: {
                smId: "",
            },
            tables: false,
            mxHeight: 0,
            tabForm: [],
            mxForm: mxForm,
            footForm: [],
            tableData: [],
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],

            },
            getRequestData: {
                page: 1,
                rows: 30,
                fgId: ''
            },
            comId: ''
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {

    },
    //方法集合
    methods: {
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        initActionBox() {
            this.$emit('drawerCancel')
        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
        },
        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.queryRecordCargoownerMoney({
                ids:[this.comId]
            });
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData));
                this.returnData.list = resData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.comId = oldData.comId
            this.showTabs = this.actionData.formData[0].jciName
            this.dataActionBox.boxTitle = "付款记录";
            this.dataActionBox.openMode = "rtl";
            this.getRequestData.fgId = oldData.fgId
            this.getDataList()
            this.filterMainField()
            this.$nextTick(() => {
                this.mxHeight = document.documentElement.clientHeight - 150;
            }
            );
        },
        // 过滤表单不同类型
        filterMainField() {
            // this.mxForm = JSON.parse(JSON.stringify(this.formDataList[1].jurconfigform))
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.foot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #fff;
    padding: 14px 0;
    z-index: 999;
}

.foot .el-form {
    margin-left: 20px;
}

.foot .el-form .el-form-item {
    margin-bottom: 0;
}

.el-drawer {
    outline: none;
}

.mb {
    margin-bottom: 0;
}

.newInput {
    height: 28px;
    line-height: 28px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}

.el-picker-panel a {
    text-decoration-line: none !important;
}
</style>